import { Box } from '@primer/react';
import { useSelector } from 'react-redux';
import Page from '../../components/ui/page';
import { RootState } from '../../state/reducers';
import ThuPhiHocSinh from './ThuPhiHocSinh';
import ThuPhiTabs from './ThuPhiTabs';
import DanhSachHocSinhPage from '../thu-phi/danh-sach-hoc-sinh/DanhSachHocSinhPage';

const HOC_SINH_TAB_ID = "hoc-sinh";

const ThuPhiTabLayout = () => {
    const { selectedId } = useSelector((x: RootState) => x.thuPhiTab);
    const showDanhSachHocSinh = !selectedId || selectedId === HOC_SINH_TAB_ID;
    
    return (
        <Page title='Thu phí'>
            <Box>
                <ThuPhiTabs />
            </Box>
            <Box>
                {showDanhSachHocSinh ? (
                    <DanhSachHocSinhPage/>
                ) : (
                    <ThuPhiHocSinh selectedTabId={selectedId} />
                )}
            </Box>

        </Page>
    );
};

export default ThuPhiTabLayout;